export const HISTORIC_ROUTES_CONSTANTS = Object.freeze({
  HOME: '/home',
});
